import { motion } from 'framer-motion';
import Box from './Box';
export var MotionBox = motion.custom(Box);